var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comingSoon"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("网站建设中，敬请期待……")]),_c('img',{attrs:{"src":require("../assets/img/comingsoon.svg"),"alt":""}})])])
}]

export { render, staticRenderFns }